<rask-cards>
    @for (fraga of grupp.fragor; track $index) {
        <rask-kontrakt-checklist-fraga [fraga]="fraga"></rask-kontrakt-checklist-fraga>
    }
</rask-cards>